// LanguageSwitcher.js

import React from "react";
import { useLanguage } from "./LanguageContext";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "de" : "en";
    changeLanguage(newLanguage);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ marginRight: "10px", fontWeight: "bold" }}>EN</span>
      <CustomSwitch checked={language === "de"} onChange={toggleLanguage} />
      <span style={{ marginLeft: "10px", fontWeight: "bold" }}>DE</span>
    </div>
  );
};

const CustomSwitch = styled(Switch)({
  width: 40,
  height: 20,
  padding: 0,
  margin: 1,
  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
    borderRadius: "50%",
    transition: "transform 0.3s",
    transform: "translateX(-50%) translateY(-50%)", // Adjust thumb position
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    border: "1px solid grey",
    backgroundColor: "#ccc",
    opacity: 1,
    transition: "background-color 0.3s",
  },
  "& .MuiSwitch-thumb.Mui-checked": {
    transform: "translateX(20px) translateY(-50%)", // Adjust the thumb positioning
  },
  "& .MuiSwitch-track.Mui-checked": {
    //backgroundColor: "#3f51b5",
    border: "none",
  },
});

export default LanguageSwitcher;
